import { defineStore } from "pinia";
import APIRequest from '@/libs/cloud_auth';
import { useAppStore } from "../app";

const SUBMODULES_LIST = [
   "conferences",
   "scheduler",
   "presentations",
   "templates",
   "players",
   "gallery",
   "playlists",
   "troubleshooting",
   "logger",
   "management",
   "devices",
   "usage",
   "settings",
   "composer"
]

export const useMetricsStore = defineStore('metrics', {
  state: () => ({
  }),
  getters: {
  },
  actions: {
    getMetrics(interval = 'week', list = 'all', tenants){
        const selectedTenants = !tenants || !tenants.length ? useAppStore().getListedHotels : tenants 
        return new Promise((resolve, reject) => {
            APIRequest('metrics/submodules/?interval=' + interval, 'post',
                {
                    tenants: selectedTenants,
                    submodules: list === "all" ? SUBMODULES_LIST : [list]
                })
                .then((response) => {
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                }
            );
        }); 
    },
    getPropertyMetrics(interval = 'week', list = 'all', tenants){
        const selectedTenants = !tenants || !tenants.length ? useAppStore().getListedHotels : tenants 
        return new Promise((resolve, reject) => {
            APIRequest('metrics/property-applications/?interval=' + interval, 'post',
                {
                    tenants: selectedTenants,
                    modules: list === "all" ? SUBMODULES_LIST : [list]
                })
                .then((response) => {
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                }
            );
        }); 
    },
  },
})